import { Box, Typography } from "@mui/material";
import { APP_BUILD_INFO } from "../../generated/buildInfo";

type AppVersionBadgeProps = {
  variant?: "login" | "dashboard";
};

const badgeStyles = {
  login: {
    px: 1.25,
    py: 0.5,
    borderRadius: 999,
    border: "1px solid rgba(15, 23, 42, 0.1)",
    backgroundColor: "rgba(248, 250, 252, 0.92)",
  },
  dashboard: {
    px: 1,
    py: 0.5,
    borderRadius: 1.5,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    backgroundColor: "rgba(255,255,255,0.9)",
  },
} as const;

export default function AppVersionBadge({
  variant = "dashboard",
}: AppVersionBadgeProps) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        ...badgeStyles[variant],
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontFamily: "monospace",
          fontSize: variant === "login" ? "0.72rem" : "0.7rem",
          letterSpacing: 0.2,
          lineHeight: 1,
        }}
      >
        {APP_BUILD_INFO.displayVersion}
      </Typography>
    </Box>
  );
}
